const getMainApplicant = (props) => ((props.record || {}).applicants || [{}])[0];

export default getMainApplicant;
